import Axios from 'axios'
import Store from '../store/store'
import Router from '../router/index'
import Qs from 'qs'
import { baseUrls } from '../settings.js'
import { EventBus, ORCAMENTO_EDIT_FORBIDDEN_EVENT } from '../helpers/eventBus'

var httpPendingRequestList = [];

const httpFunctions = {
    cancelPendingRequests: function () {
        httpPendingRequestList.forEach((item) => {
            item.cancel("Request canceled in axios-config...");
        });
        httpPendingRequestList = [];
    }
};

const http = Axios.create({
    baseURL: baseUrls.api,
    headers: {
        'Content-Type': 'application/json'
    },
    paramsSerializer: function (params) {
        return Qs.stringify(params, { arrayFormat: 'brackets' })
    },
})

http.interceptors.request.use(
    config => {
        config.headers['X-Api-Key'] = Store.state.login.xApiKey;
        let source = Axios.CancelToken.source();
        config.cancelToken = source.token;
        httpPendingRequestList.push(source);
        if (!config.silent) {
            Store.commit('ui/LOADING', true);
        }
        return config;
    },
    error => {
        if (!error.config || !error.config.silent) {
            Store.commit('ui/LOADING', false);
        }
        return Promise.reject(error)
    }
);

http.interceptors.response.use((response) => {
    if(!response.config.silent){
        Store.commit('ui/LOADING', false);
    }
    return response;
}, (error) => {
    if (!error.config || !error.config.silent) {
        Store.commit('ui/LOADING', false);
    }
    if (
        error.response &&
        error.response.status === 403 &&
        error.response.data &&
        error.response.data.code === 'ORCAMENTO_EDIT_FORBIDDEN'
    ) {
        EventBus.$emit(ORCAMENTO_EDIT_FORBIDDEN_EVENT);
    }
    if (error.response && error.response.status === 401) {
        if (!Router.currentRoute.path.includes('login')) {
            Store.commit('ui/MSG', error.response.data.msg);
            Store.commit('ui/MSG_TYPE', error.response.data.type);
            Router.push("/login");
        }
    }
    return Promise.reject(error);
});

export { http };
export { httpFunctions };
